"use client";

import React, { createContext, useContext } from "react";

export interface VideoPlayerContextValue {
  duration: number;
  videoRef: React.RefObject<HTMLVideoElement | null>;
  enableClipRange?: boolean;
  clipRange?: { startTime: number; duration: number };
  onClipRangeChange?: (startTime: number) => void;
  setClipRangeStartTime?: (startTime: number) => void;
  pause?: () => void;
  seekTo?: (time: number) => void;
  showControls?: boolean;
}

export const VideoPlayerContext = createContext<VideoPlayerContextValue | null>(
  null
);

export const useVideoPlayerContext = () => {
  const context = useContext(VideoPlayerContext);
  if (!context) {
    // Falls back gracefully if used outside, or we can enforce it
    return null;
  }
  return context;
};

export const VideoPlayerProvider: React.FC<{
  value: VideoPlayerContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <VideoPlayerContext.Provider value={value}>
      {children}
    </VideoPlayerContext.Provider>
  );
};
